import { render, staticRenderFns } from "./profile-tab.vue?vue&type=template&id=590d3433&"
import script from "./profile-tab.vue?vue&type=script&lang=js&"
export * from "./profile-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports